__turbopack_context__.v({
  "videoUrlLabel": "YoutubeFields-module__iXEA_a__videoUrlLabel",
  "youtubeFieldset": "YoutubeFields-module__iXEA_a__youtubeFieldset",
  "youtubeHeading": "YoutubeFields-module__iXEA_a__youtubeHeading",
});
